<div class="annual-report">
    <div class="container">
        <div class="row">
            <!-- section title -->
            <div class="col-md-12 my-md-5 mb-5 sec-title">
                <app-title-page [dataTitle]="dataTitle" [link]="'#report-doc'"></app-title-page>
            </div>
            <!-- documents -->
            <div class="col-md-12 documents" id="report-doc">
                <div class="lane-top">
                    <div class="row mt-5 px-md-0 px-2">
                        <div class="col-md-3 col-6 px-sm-3 px-2 pb-4" 
                             data-aos="fade-up"
                            *ngFor="let doc of dataAnnual">
                            <app-docs [dataDocs]="doc"></app-docs>
                        </div>
                    </div>
                    <div class="row mt-4" *ngIf="btnLoad">
                        <div class="col-lg-3 col-md-4 col-9 mx-auto">
                            <button [disabled]="textLoad == 'Loading...'"
                                    class="btn more red-btn w-100" 
                                    (click)="getMore()">
                                    {{ textLoad }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</div>
